import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#f67d4a",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2d2a29",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fdfcfb",
      paper: "#ffffff",
      card: "#ffffff",
    },
    text: {
      primary: "#2d2a29",
      secondary: "#6e6b68",
    },
    divider: "#eae7e5",
    action: {
      active: "#f67d4a",
      hover: "rgba(246, 125, 74, 0.04)",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: "#ffffff",
          backgroundImage: "none",
          border: "1px solid #eae7e5",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.02)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 12px 40px rgba(246, 125, 74, 0.05)",
            borderColor: "rgba(246, 125, 74, 0.3)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#ffffff",
          border: "1px solid #eae7e5",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.02)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
        colorPrimary: {
          backgroundColor: "#f67d4a",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#ffffff",
            "& fieldset": {
              borderColor: "#eae7e5",
            },
            "&:hover fieldset": {
              borderColor: "#f67d4a",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          "& fieldset": {
            borderColor: "#eae7e5",
          },
          "&:hover fieldset": {
            borderColor: "#f67d4a",
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff",
          backgroundImage: "none",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          backgroundImage: "none",
          border: "1px solid #eae7e5",
          boxShadow: "none",
          "&:before": {
            display: "none",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #eae7e5",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "#a0a0a0",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#f67d4a",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          "&.Mui-selected": {
            color: "#f67d4a",
          },
        },
      },
    },
  },
})

export default theme

